import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 50,
    mobile: {
      desktop: { padding: 50 },
      smartphone: { padding: 5 },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontSize: "26pt",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
    paddingBottom: 10,
  },
  SUBHEADLINE: {
    textAlign: "center",
    fontSize: "22pt",
    fontFamily: theme.fontFamily,
    // fontWeight: "bold" as "bold",
    marginTop: 20,
    color: theme.highlightColor,
  },
  TEXT: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    lineHeight: "18pt",
    padding: "20px 0",
  },
  DIVIDER: {
    marginTop: 20,
    width: 100,
    display: "inline-block",
    textAlign: "center",
  },
  BUTTON: {
    style: {
      display: "inline-block",
      padding: "15px 70px",
      margin: "0 auto",
      marginTop: 20,
      border: "none",
      backgroundColor: theme.backgroundColor,
      borderRadius: 3,
      cursor: "pointer",
      textAlign: "center",
    },
    caption1: {
      color: theme.foregroundColor,
      fontWeight: "bold" as "bold",
      fontSize: "10pt",
    },
  },
};
